import { inject, Injectable } from '@angular/core';
import { PaymentAtTableStoreSelector } from '@common/selectors/payment-at-table.selector';
import { injectConfirmationPageContext } from '@core/services/content-builder/context-expression-language.util';
import { ExpressionLanguageUtile } from '@core/services/content-builder/expression-language.utile';
import { combineLatest, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContentBuilderVariablesService {
  private readonly paymentAtTableStoreSelector = inject(PaymentAtTableStoreSelector);

  confirmationPageContext = injectConfirmationPageContext();
  // todo 👇
  // ! please update doc here when updating this service src/app/modules/pages/components/block-field-atoms/shared/content-builder-available-variables.component.ts
  get$() {
    return combineLatest({
      /**
       * Availability: With payment at table option, when a table is selected
       * Content: The table name
       * Example: "Table 1"
       * Usage: {{'{{PaymentAtTable.onSiteLocationName}}'}}
       */
      ['PaymentAtTable.onSiteLocationName']: this.paymentAtTableStoreSelector.selectCheck.pipe(
        map(check => check?.onsite_location.name.replace(/ /g, '')),
      ),
      ...this.confirmationPageContext,
    }).pipe(
      map(data => {
        const timeStamp = new Date().getTime();
        return {
          ...data,
          /**
           * Availability: Always available
           * Content: The current timestamp
           * Example: 1678901234567
           * Usage: {{'{{timeStamp}}'}}
           */
          timeStamp: new Date().getTime(),
          /**
           * Availability: With payment at table option, when a table is selected
           * Content: The table name with spaces removed, with a timestamp
           * Example: "Table 1" => "Table1-1678901234567"
           * Usage: {{'{{Dokaa.PayAtTable.OrderInfo}}'}}
           */
          ['Dokaa.PayAtTable.OrderInfo']: `${data['PaymentAtTable.onSiteLocationName'].replace(/ /g, '')}-${timeStamp}`,
        };
      }),
    );
  }

  parseContentBuilderString$(string: string, context?: Record<string, any>) {
    return this.get$().pipe(
      map(data =>
        string.replace(/{{(.*?)}}/g, (_match, expression: string) => {
          const result = ExpressionLanguageUtile.parseExpressionForTemplate(expression, {
            ...data,
            ...context,
          });
          return result as string;
        }),
      ),
    );
  }
}
